import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Home from "./pages/Home";
import ConsultationPage from "./components/ConsultationPage/ConsultationPage";
import AboutPage from "./pages/about/AboutPage";
import ServicesPage from "./pages/service/ServicesPage";
import CalculatorPage from "./pages/calculator/CalculatorPage";
import EmiCalculator from "./components/calculator/emi_calculate/EmiCalculator";
import MutualFundCalculator from "./components/calculator/mutual_calculate/MutualFundCalculator";
import GoalPlanningCalculator from "./components/calculator/goal_calculate/GoalPlanningCalculator";
import CapitalGainCalculator from "./components/calculator/capital&tax_calculate/CapitalGainCalculator";
import AdvanceMFCalculator from "./components/calculator/advancemf_calculate/AdvancedMFCalculator";
import ComparisonCalculator from "./components/calculator/camparison_calculate/ComparisonCalculator";
import InflationCalculator from "./components/calculator/Inflation_calculate/InflationCalculator";
import PartnerCalculator from "./components/calculator/partner_calculate/PartnerCalculator";
import Disclaimer from "./pages/disclaimer/Disclaimer";
import ContactPage from "./pages/contact/ContactPage";
import WealthPage from "./pages/wealth/WealthPage";
import MotilalOswalPage from "./pages/partners/MotilalOswalPage";
import NJWealthPage from "./pages/partners/NJWealthPage";
import TermsAndConditions from "./pages/termsandcondition/TermsAndConditions";
import PrivacyPolicy from "./pages/privacypolicy/PrivacyPolicy";
import RegulatoryInfo from "./pages/RegulatoryInformation/RegulatoryInfo";
import SupportPage from "./pages/Support/SupportPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/calculators" element={<CalculatorPage />} />
        <Route path="/calculators/emi-calculate" element={<EmiCalculator />} />
        <Route
          path="calculators/mutual-calculate"
          element={<MutualFundCalculator />}
        />
        <Route
          path="calculators/goal-calculate"
          element={<GoalPlanningCalculator />}
        />
        <Route
          path="calculators/capital-tax-calculate"
          element={<CapitalGainCalculator />}
        />
        <Route
          path="calculators/advance-mutual-calculate"
          element={<AdvanceMFCalculator />}
        />
        <Route
          path="calculators/comparison-inflation-calculate"
          element={<ComparisonCalculator />}
        />
        {/* <Route
          path="calculators/partner-calculate"
          element={<PartnerCalculator />}
        /> */}
        <Route
          path="/calculators/inflation-calculate"
          element={<InflationCalculator />}
        />
        <Route path="disclaimer" element={<Disclaimer />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/wealth" element={<WealthPage />} />
        <Route path="/motilal-oswal" element={<MotilalOswalPage />} />
        <Route path="/nj-wealth" element={<NJWealthPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/regulatory-information" element={<RegulatoryInfo />} />
        <Route path="/support" element={<SupportPage />} />
      </Routes>
    </Router>
  );
}

export default App;
